import type { ReactNode } from "react";

import WelcomeTourDialog from "@/components/WelcomeTourDialog";
import { useTourScrollLock } from "@/hooks/use-tour-scroll-lock";

import TourJoyride from "./TourJoyride";
import type { ITourShellProps } from "./types";

export const TourShell = ({
  children,
  isWelcomeOpen,
  onStartTour,
  onWelcomeClose,
  welcomeTitleKey,
  welcomeDescriptionKey,
  joyride,
}: ITourShellProps): ReactNode => {
  // NOTE: NSAI-5895 — held here rather than in each provider so all three tours
  // (main, call assistant, admin) get the same guarantee from the one component
  // they already share.
  useTourScrollLock({ isLocked: joyride.isRunning });

  return (
    <>
      {children}

      <WelcomeTourDialog
        isOpen={isWelcomeOpen && !joyride.isRunning}
        onStartTour={onStartTour}
        onClose={onWelcomeClose}
        titleKey={welcomeTitleKey}
        descriptionKey={welcomeDescriptionKey}
      />

      <TourJoyride {...joyride} />
    </>
  );
};
